export const changePointByComma = (text) => {
    return text?.toString().replace(/\./g, ',');
}

export const changeCommaByPoint = (text) => {
    return text?.toString().replace(/,/g, '\.');
}